import { axios } from '@/utils/request'
import api2 from './index'

const api = {
  operLog: api2.gateway_system+'operLog',
  loginLog: api2.gateway_system+'logininfor',
}

export default api

// OperLog
export function getOperLogList (parameter) {
  return axios({
    url: api.operLog + '/list',
    method: 'get',
    params: parameter
  })
}

export function delOperLog (parameter) {
  return axios({
    url: api.operLog + '/remove',
    method: 'post',
    params: parameter
  })
}
export function cleanOperLog () {
  return axios({
    url: api.operLog + '/clean',
    method: 'post'
  })
}
// LoginLog
export function getLoginLogList (parameter) {
  return axios({
    url: api.loginLog + '/list',
    method: 'get',
    params: parameter
  })
}
export function delLoginLog (parameter) {
  return axios({
    url: api.loginLog + '/remove',
    method: 'post',
    params: parameter
  })
}
export function cleanLoginLog () {
  return axios({
    url: api.loginLog + '/clean',
    method: 'post'
  })
}
export function online_list(parameter) {
  return axios({
    url: api2.gateway_system+'online/list',
    method: 'get',
    params: parameter
  })
}
export function force_logout(parameter) {
  return axios({
    url: api2.gateway_system+'online/force_logout',
    method: 'post',
    data: parameter
  })
}

export const operLogExport = api.operLog + '/export'
